import { render, staticRenderFns } from "./ForkMe.vue?vue&type=template&id=69e86f70&"
import script from "./ForkMe.vue?vue&type=script&lang=js&"
export * from "./ForkMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports